<div class="contents-area" (dragstart)="onDragstartBody($event)">
  <div class="column-list">
    <label class="list-input-title">対象</label>
    <div class="list-input-content radio-group">
      <!-- 対象から "承認マスタ" を外すためコメントアウト -->
      <!-- <app-radio-label id="rdb_GoodsCategory" #rdb_GoodsCategory [subid]="'rdb_GoodsCategory'"
        [(ngModel)]="kymw6800Model.radioGroup" groupName="grp_CategoryDiv" label="商品マスタ" value="0"
        (change)="eventCategoryDiv_CHANGEHandler()" [forcedEnabledMode]="'true'" [tabindex]="0">
      </app-radio-label> -->
      <app-radio-label id="rdb_PlanCategory" #rdb_PlanCategory [subid]="'rdb_PlanCategory'"
        [(ngModel)]="kymw6800Model.radioGroup" groupName="grp_CategoryDiv" label="商品企画マスタ" value="2"
        (change)="eventCategoryDiv_CHANGEHandler()" [forcedEnabledMode]="'true'" [tabindex]="0">
      </app-radio-label>
      <app-radio-label id="rdb_StockLimitFlg" #rdb_StockLimitFlg [subid]="'rdb_StockLimitFlg'"
        [(ngModel)]="kymw6800Model.radioGroup" groupName="grp_CategoryDiv" label="在庫限定" value="3"
        (change)="eventCategoryDiv_CHANGEHandler()" [forcedEnabledMode]="'true'" [tabindex]="0">
      </app-radio-label>
    </div>
  </div>
  <div class="split_two_part">
    <div>
      <h1>カテゴリ一覧</h1>
      <div class="element-column">
        <button class="btn-secondary" id="btn_Display" #btn_Display (click)="eventDisplay_CLICKHandler()"
          forcedEnabledMode="true" [tabindex]="0">表示</button>

        <wj-tree-view class="tree" id="tre_Category" #tre_Category
          [itemsSource]="kymw6800Model.categoryInfoList" [displayMemberPath]="'CategoryName'"
          [childItemsPath]="'Category'" (itemClicked)="eventSelect_CLICKHandler()" [expandOnLoad]="false"
          (keydown)="eventKeybordSelect_KEYDOWNHandler($event)" forcedEnabledMode="none" [tabindex]="0"
          (formatItem)="formatItem(tre_Category, $event)">
        </wj-tree-view>
      </div>
    </div>

    <div>
      <h1>カテゴリ変換マスタ一覧</h1>
      <wj-flex-grid id="dtg_CategoryConvList" #dtg_CategoryConvList [itemsSource]="kymw6800Model.categoryConvList"
        [headersVisibility]="'Column'" [isReadOnly]="true" [tabindex]="0" forcedEnabledMode="true">
        <wj-flex-grid-column [minWidth]="5" [width]="110" [header]="'変換区分'"
          [binding]="'ConvDiv'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="160" [header]="'ｶﾃｺﾞﾘ'"
          [binding]="'CategoryCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'部門'"
          [binding]="'ClassCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'大分類'"
          [binding]="'LargeClassCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'中分類'"
          [binding]="'MiddleClassCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'小分類'"
          [binding]="'SmallClassCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="225" [header]="'ﾏｰｸ1'"
          [binding]="'MarkCode1'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="225" [header]="'ﾏｰｸ2'"
          [binding]="'MarkCode2'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="225" [header]="'ﾏｰｸ3'"
          [binding]="'MarkCode3'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'価格ﾊﾟﾀｰﾝ'"
          [binding]="'PricePattern'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'媒体区分'"
          [binding]="'MediumType'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'特集'"
          [binding]="'FeatureCode'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="94" [header]="'ﾍﾟｰｼﾞ番号'"
          [binding]="'PageNum'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="140" [header]="'ﾌﾟﾛﾓｰｼｮﾝ区分'"
          [binding]="'PromotionDiv'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'ﾌﾟﾛﾓｰｼｮﾝ情報'"
          [binding]="'PromotionInfo'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="85" [header]="'催事区分'"
          [binding]="'ExhibitionDiv'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="165" [header]="'ﾀｸﾞ1'"
          [binding]="'Tag1'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="165" [header]="'ﾀｸﾞ2'"
          [binding]="'Tag2'"></wj-flex-grid-column>
      </wj-flex-grid>
    </div>
  </div>
</div>

<footer class="footer-buttons">
  <button class="btn-secondary" id="btn_Output" (click)="eventOut_CLICKHandler()" forcedEnabledMode="true"
    [tabindex]="0">出力</button>
  <button class="btn-primary" id="btn_Entry" #btn_Entry (click)="eventEntry_CLICKHandler()" forcedEnabledMode=""
    [tabindex]="0">登録</button>
</footer>